import React, { useState } from 'react';
import './TaskForm.css';

function TaskForm({ phases, onSubmit, initialData = null, onCancel }) {
  const [formData, setFormData] = useState(initialData || {
    title: '',
    description: '',
    phase_id: '',
    priority: 2,
    cost: 0,
    estimated_start_date: '',
    estimated_end_date: '',
    contractor: '',
    status: 'A faire'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: name === 'cost' ? parseFloat(value) : name === 'phase_id' ? parseInt(value) : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.title || !formData.phase_id) {
      alert('Titre et phase sont obligatoires');
      return;
    }
    try {
      await onSubmit(formData);
      if (!initialData) {
        setFormData({
          title: '',
          description: '',
          phase_id: '',
          priority: 2,
          cost: 0,
          estimated_start_date: '',
          estimated_end_date: '',
          contractor: '',
          status: 'A faire'
        });
      }
    } catch (err) {
      alert('Erreur: ' + err.message);
    }
  };

  return (
    <form className="task-form" onSubmit={handleSubmit}>
      <h3>{initialData ? 'Modifier la tâche' : 'Ajouter une nouvelle tâche'}</h3>
      
      <div className="form-group">
        <label>Titre *</label>
        <input
          type="text"
          name="title"
          value={formData.title}
          onChange={handleChange}
          placeholder="Ex: Creusage des fondations"
          required
        />
      </div>

      <div className="form-group">
        <label>Description</label>
        <textarea
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="Détails de la tâche..."
          rows="3"
        />
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Phase *</label>
          <select
            name="phase_id"
            value={formData.phase_id}
            onChange={handleChange}
            required
          >
            <option value="">-- Sélectionner une phase --</option>
            {phases.map(phase => (
              <option key={phase.id} value={phase.id}>
                {phase.nom}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Priorité</label>
          <select name="priority" value={formData.priority} onChange={handleChange}>
            <option value={1}>🔴 Urgente</option>
            <option value={2}>🟡 Normale</option>
            <option value={3}>🟢 Basse</option>
          </select>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Coût estimé (€)</label>
          <input
            type="number"
            name="cost"
            value={formData.cost}
            onChange={handleChange}
            step="0.01"
            min="0"
          />
        </div>

        <div className="form-group">
          <label>Statut</label>
          <select name="status" value={formData.status} onChange={handleChange}>
            <option value="A faire">À faire</option>
            <option value="En cours">En cours</option>
            <option value="Devis">Devis</option>
            <option value="Terminé">Terminé</option>
          </select>
        </div>
      </div>

      <div className="form-row">
        <div className="form-group">
          <label>Début estimé</label>
          <input
            type="date"
            name="estimated_start_date"
            value={formData.estimated_start_date}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label>Fin estimée</label>
          <input
            type="date"
            name="estimated_end_date"
            value={formData.estimated_end_date}
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="form-group">
        <label>Entrepreneur/Fournisseur</label>
        <input
          type="text"
          name="contractor"
          value={formData.contractor}
          onChange={handleChange}
          placeholder="Ex: Entreprise ABC"
        />
      </div>

      <div className="form-actions">
        <button type="submit" className="btn btn-primary">
          {initialData ? '✏️ Modifier' : '➕ Ajouter la tâche'}
        </button>
        {onCancel && (
          <button type="button" className="btn btn-secondary" onClick={onCancel}>
            Annuler
          </button>
        )}
      </div>
    </form>
  );
}

export default TaskForm;
